import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import { Layout } from "antd";

import "../../App.css";
import { StakeholdersView } from "./StakeholdersView";
import { ProgrammesView } from "./ProgrammesView";
import { BackgroundView } from "./BackgroundView";
import { CorousalView } from "./CorousalView";
import MyProgrammeView from "./MyProgrammeView";
import {
  RenderAuthenticated,
  RenderAnonymous,
} from "@seims/shared/src/security";

const { Header, Content, Footer } = Layout;

export const HomeView = () => {

  return (
    <>
      <RenderAuthenticated>
        <MyProgrammeView />
      </RenderAuthenticated> 

      <RenderAnonymous>
        <CorousalView />
        <BackgroundView />
        <ProgrammesView />
        <StakeholdersView />
      </RenderAnonymous>

    </>
  );
};
